<template>
  <div>
    <homeWeb v-if="!isMobile"></homeWeb>
    <homeMobile v-if="isMobile"></homeMobile>
  </div>
</template>
<script>
import homeWeb from './Home-web.vue'
import homeMobile from './Home-mobile.vue'
export default {
  name: 'home',
  data() {
    return {
      isMobile: true
    }
  },
  components: {
    homeWeb,
    homeMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
